import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRight.js";
import { Link } from "@mui/material";
import { styled } from "@mui/material/styles";
const ArrowIcon = styled(ArrowRightIcon)(({ theme }) => ({
  width: 24,
  height: 24,
  color: theme.palette.primary[800]
}));
const Wrapper = styled(Link)(({ theme }) => ({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: theme.spacing(2),
  width: 24,
  height: 24,
  border: "1px solid",
  borderColor: theme.palette.primary[800],
  borderRadius: 12,
  marginRight: 5
}));
export {
  ArrowIcon,
  Wrapper
};
